import React, { useState } from 'react';
import { LayoutDashboard, Bell, Settings, UserCircle } from 'lucide-react';
import { Role, ProcessorGoal, ManagerTeamGoal } from './types/goals';
import { ProcessorGoalCard } from './components/ProcessorGoalCard';
import { ManagerGoalTable } from './components/ManagerGoalTable';
import { RoleSelector } from './components/RoleSelector';
import { MonthSelector } from './components/MonthSelector';
// Mock Data
const MOCK_PROCESSOR_GOAL: ProcessorGoal = {
  id: '1',
  month: '2023-10',
  ctcGoal: 15,
  ctcActual: 12,
  pipeline: {
    underwriting: 3,
    awc: 8,
    appraisalBack: 4
  },
  weeklyProgress: [{
    weekLabel: 'Week 1',
    actual: 3,
    goal: 4,
    isCurrentWeek: false
  }, {
    weekLabel: 'Week 2',
    actual: 4,
    goal: 4,
    isCurrentWeek: false
  }, {
    weekLabel: 'Week 3',
    actual: 5,
    goal: 4,
    isCurrentWeek: true
  }, {
    weekLabel: 'Week 4',
    actual: 0,
    goal: 3,
    isCurrentWeek: false
  }]
};
const MOCK_TEAM_GOAL: ManagerTeamGoal = {
  id: 'team-1',
  month: '2023-10',
  processors: [{
    id: 'proc-1',
    name: 'Sarah Jenkins',
    ctcGoal: 15,
    ctcActual: 14,
    pipeline: {
      underwriting: 2,
      awc: 6,
      appraisalBack: 3
    }
  }, {
    id: 'proc-2',
    name: 'Michael Chen',
    ctcGoal: 18,
    ctcActual: 16,
    pipeline: {
      underwriting: 4,
      awc: 9,
      appraisalBack: 5
    }
  }, {
    id: 'proc-3',
    name: 'David Wilson',
    ctcGoal: 12,
    ctcActual: 8,
    pipeline: {
      underwriting: 1,
      awc: 4,
      appraisalBack: 2
    }
  }, {
    id: 'proc-4',
    name: 'Amanda Ross',
    ctcGoal: 20,
    ctcActual: 19,
    pipeline: {
      underwriting: 3,
      awc: 11,
      appraisalBack: 6
    }
  }, {
    id: 'proc-5',
    name: 'James Miller',
    ctcGoal: 16,
    ctcActual: 15,
    pipeline: {
      underwriting: 2,
      awc: 7,
      appraisalBack: 4
    }
  }]
};
export function App() {
  const [role, setRole] = useState<Role>('PROCESSOR');
  const [month, setMonth] = useState<string>(new Date().toISOString().slice(0, 7));
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900" data-id="element-0">
      {/* Navigation Bar */}
      

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1">
        {/* Page Header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8" data-id="element-2">
          <div data-id="element-3">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-4">
              {role === 'PROCESSOR' ? 'Pipeline Dashboard' : 'Team Pipeline Overview'}
            </h1>
            <p className="text-slate-500 mt-1" data-id="element-5">
              {role === 'PROCESSOR' ? 'Track your active files and monthly progress' : 'Monitor team pipeline and identify bottlenecks'}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center" data-id="element-6">
            <RoleSelector currentRole={role} onChange={setRole} data-id="element-7" />
            <div className="h-8 w-px bg-slate-200 hidden sm:block" data-id="element-8"></div>
            <MonthSelector selectedMonth={month} onChange={setMonth} data-id="element-9" />
          </div>
        </div>

        {/* Dashboard Content */}
        <div className="animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-10">
          {role === 'PROCESSOR' ? <ProcessorGoalCard goal={MOCK_PROCESSOR_GOAL} data-id="element-11" /> : <ManagerGoalTable teamGoal={MOCK_TEAM_GOAL} data-id="element-12" />}
        </div>
      </main>
    </div>;
}